<template>
  <form class="search-form mt-[70px]">
    <div class="relative w-full">
      <input
        class="search-input w-full rounded-[25px] bg-white appearance-none focus:outline-none placeholder-italic text-base leading-tight placeholder-[hsla(223,5%,73%,1)]"
        type="text"
        placeholder="Search the Geeq blockchain"
        v-model="searchStr"
        @keyup.enter.prevent="search"
      >
      <button
        @click.prevent="search"
        class="search-btn bg-blue-light absolute right-[4px] top-[4px] flex items-center justify-center"
        :class="{ 'search-btn--loading': isLoadingInProgress }"
        type="submit"
        aria-label="Search"
      >
        <div v-if="isLoadingInProgress" class="flex items-center justify-center">
          <Loader color="#FFFFFF" width="20px" height="20px" />
        </div>
        <span v-else aria-hidden="true"></span>
      </button>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex';
import Loader from '@/components/common/Loader.vue';

export default {
  name: 'SearchFormMobile',
  components: {
    Loader,
  },
  computed: {
    ...mapState({
      isLoadingInProgress: state => state.isLoadingInProgress,
    }),
  },
  data: () => {
    return {
      searchStr: '',
    };
  },
  methods: {
    search() {
      if (this.isLoadingInProgress) {
        return;
      }
      this.$store.dispatch('searchBlockchain', this.searchStr);
    },
    resetForm() {
      this.searchStr = '';
    },
  },
};
</script>

<style scoped>
</style>